import {
    ALL_EMPLOYEES_IN_CONTRACT_FETCHING,
    ALL_EMPLOYEES_IN_CONTRACT_FAILED,
    ALL_EMPLOYEES_IN_CONTRACT_SUCCESS,
  } from "../actions/types";
  
  const initialState = {
    result: null,
    isFetching: false,
    isError: false,
  };
  
  export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case ALL_EMPLOYEES_IN_CONTRACT_FETCHING:
        return { ...state, result: null, isFetching: true, isError: false };
      case ALL_EMPLOYEES_IN_CONTRACT_FAILED:
        return { ...state, result: null, isFetching: false, isError: true };
      case ALL_EMPLOYEES_IN_CONTRACT_SUCCESS:
        return { ...state, result: payload, isFetching: false, isError: false };
      default:
        return state;
    }
  }
  